module.exports = "images/logo.jpg";